import React from 'react';
import { Box, Text, Button, Center } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <Center h="90vh" flexDirection="column">
      <Box textAlign="center" p={6}>
        <Text fontSize="6xl" fontWeight="bold">
          404
        </Text>
        <Text fontSize="2xl" mb={4}>
          Oops! The page you are looking for doesn't exist.
        </Text>
        <Link to="/">
          <Button size="lg">
            Go Back to Home
          </Button>
        </Link>
      </Box>
    </Center>
  );
};

export default NotFoundPage;
